class BeePopup
{
   constructor(elementId, settings = {})
   {
      this.elementId = elementId;
      this.settings = settings;
      this.init();
   }

   setCookie = (cname, cvalue, exhours) =>
   {
      const d = new Date();
      d.setTime(d.getTime() + (exhours * 60 * 60 * 1000));
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
   }

   getCookie = (cname) =>
   {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++)
      {
         let c = ca[i];
         while (c.charAt(0) == ' ')
         {
            c = c.substring(1);
         }
         if (c.indexOf(name) == 0)
         {
            return c.substring(name.length, c.length);
         }
      }
      return "";
   }

   init = () =>
   {
      if( !this.getCookie('bee-popup') )
      {
         setTimeout(() => {
            Fancybox.show([{ src: `#${this.elementId}`, type: "clone" }], {
               dragToClose: false,
               Panzoom : {
                  touch: false
               },
               on: {
                  close: () =>
                  {
                     this.setCookie('bee-popup', 'false', this.settings.expiryHours);
                     console.log('onClose event fired');
                  }
               }
            });
         }, this.settings.delay * 1000);
      }
   }
}